module.exports = __webpack_public_path__ + "img/computer-simulations-logo.735cc240.svg";